let element = document.getElementById('js-job-opportunities');
let filters = JSON.parse(element?.getAttribute('data-filters') ?? '{}');
let api = element?.getAttribute('data-job-opportunities-api') ?? '';

var information = {
	filters,
	api,
};

export default information;
